import { render } from "./categoriesPage.vue?vue&type=template&id=09cc63f8"
import script from "./categoriesPage.vue?vue&type=script&lang=js"
export * from "./categoriesPage.vue?vue&type=script&lang=js"

import "./categoriesPage.vue?vue&type=style&index=0&id=09cc63f8&lang=css"

import exportComponent from "/Users/hamzaassif/Work/detect-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__